import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import i18next from 'i18next';
// import { useSocket } from '~/hooks/socket';

import Card from '~/components/Card';
import { PrimaryButton } from '~/components/Button';
import ChatItem from '../ChatItem';

import {
  Container,
  Title,
  Scroll,
  Header,
  HeaderRight,
  WrapperButton,
  NoData,
} from './styles';

function Chat() {
  const { lastTicket } = useSelector((state) => state.holders);
  // const { attendances } = useSocket();

  const history = useHistory();

  return (
    <Card>
      <Container>
        <Header>
          <Title>{i18next.t('demandManagement.demandDetails.chat')}</Title>
          <HeaderRight>
            <WrapperButton>
              <PrimaryButton
                small
                label={i18next.t('demandManagement.chat.access')}
                padding="0 2rem"
                width="null"
                onClick={() =>
                  history.push({
                    pathname: '/chat/',
                    state: { protocol: lastTicket?.id },
                  })
                }
              />
            </WrapperButton>
          </HeaderRight>
        </Header>
        {/* <Scroll>
          {attendances && attendances.length > 0 ? (
            attendances.map((item) => <ChatItem key={item.id} item={item} />)
          ) : (
            <NoData>{i18next.t('demandManagement.chat.noData')}</NoData>
          )}
        </Scroll> */}
      </Container>
    </Card>
  );
}

export default Chat;
